

<template>
	<section>
        <header class="detail-title">Amazon移库计划产品行</header>
        <Form :label-width="120" inline v-if="search">
            <FormItem label='ERP SKU:'>
                <Select v-model="formData.erpSku" filterable @on-query-change="getErpskuList" clearable @on-change="getInventory">
                    <Option v-for="item in erpskulist" :value="item.sku" :key="item.sku">{{ item.sku }}</Option>
                </Select>
                <!-- <Input clearable v-model="formData.erpSku" @on-blur="getInventory"/> -->
            </FormItem>
            <FormItem label='Seller SKU:'>
                <Input clearable v-model="formData.sellerSku" @on-blur="getInventory"/>
            </FormItem>
            <FormItem label='当前库存:'>
                <span>{{formData.inventoryCurrent!==''?formData.inventoryCurrent:'-'}}</span>
            </FormItem>
            <FormItem label='可用库存:'>
                <span>{{formData.inventoryAvailable!==''?formData.inventoryAvailable:'-'}}</span>
            </FormItem>
            <FormItem label='预计发运数量:'>
                <InputNumber clearable v-model="formData.trasferAmount " :min='0'/>
            </FormItem>
            <FormItem :label-width="1">
                 <Button  @click="addItem" icon="md-add" type="primary">添加</Button>
            </FormItem>
        </Form>
		<Table
        style="margin:0 16px"
		:columns="columns" 
		:data="data"
		size="small" 
		ref="table"  
		border 
		stripe></Table>
        <!-- <div style="    position: relative;height: 200px;overflow: auto;">
            <div style="    position: relative;height: 300px;">ssss</div>
            <div style="    position: absolute;height: 600px;background:red;top:200px;">sssssssssssssssssssssssssssss</div>
        </div> -->
	</section>
</template>

<script>
import { HttpInventoryData, HttpErpskuData } from '@/service/allotment/transfer';
import { Button } from 'view-design';
export default {
    props: ['value', 'search'],
    data() {
        return {
            data: [],
            formData: {
                trasferAmount: ''
            },
            erpskulist: []
        };
    },

    watch: {
        value() {
            this.data = this.value;
        },
        data(val) {
            this.$emit('input', val)
        }
    },

    methods: {
        addItem() {
            const { trasferAmount, erpSku, sellerSku } = this.formData
            if (trasferAmount && erpSku && sellerSku) {
                this.data.push(this.formData)
                this.formData = { trasferAmount: '' };
            } else {
                this.$Message.warning('请填写ERP SKU,Seller SKU和预计发运数量');
            }
        },
        removeItem(index) {
            this.data.splice(index, 1)
        },
        async getInventory() {
            const erpSku = this.formData.erpSku;
            const formdata = this.$parent.$refs['form'].formData || {};
            if (!erpSku) return this.formData = { trasferAmount: '' };
            HttpInventoryData({
                orgWarehouseId: formdata.orgwarehouseId,
                inventoryType: formdata.inventoryType,
                erpSku: erpSku,
                sellerSku: this.formData.sellerSku
            }).then(res => {
                const { sellerSku, name, erpSku, alias, inventoryAvailable = 0, inventoryCurrent = 0 } = res.data;
                this.formData = { sellerSku, productName: name, erpSku, dgcode: alias, trasferAmount: this.formData.trasferAmount, inventoryAvailable, inventoryCurrent }
            }, err => {
                this.errorMessage(err.message);
            });
        },
        async getErpskuList(val) {
            if (!val) return;
            const formdata = this.$parent.$refs['form'].formData || {};
            const response = await HttpErpskuData({
                orgWarehouseId: formdata.orgwarehouseId,
                inventoryType: formdata.inventoryType,
                erpSku: val,
                lineId:formdata.lineId
            }).catch(err => {
                this.errorMessage(err.message);
            });
            if (response) {
                this.erpskulist = response.data;
            }
        },
    },
    computed: {
        columns() {
            const columns = [
                {
                    title: 'ERP SKU',
                    key: 'erpSku',
                },
                {
                    title: 'Seller SKU',
                    key: 'sellerSku',
                },
                {
                    title: '产品别名',
                    key: 'dgcode',
                }, {
                    title: '产品名称',
                    key: 'productName',
                }, {
                    title: '预计发运数量',
                    key: 'trasferAmount',
                }, {
                    title: '操作',
                    render: (h, { index }) => {
                        return <Button type="error" nativeOnClick={this.removeItem.bind(this, index)}>删除</Button>
                    }
                }
            ];
            if (!this.search) {
                columns.pop()
                columns.push({
                    title: '实际发运数量',
                    key: 'shippingNum',
                }, {
                        title: '接收数量',
                        key: 'inboundAmount',
                    }, )
            };
            return columns;
        },
    },
};
</script>



